import { Box, Flex, useBreakpointValue, useColorModeValue } from "@chakra-ui/react";
import { useEffect, useRef } from "react";
import { useAppConfig } from "../../context";

import RightSidebarWidget from "./RightSidebarWidget";

function Layout({ sidebar, navbar, children }) {
  const { storedSidebarState, sidebarState, setStoredSidebarState, setSidebarState } = useAppConfig();

  // Auto-collapse the left nav whenever the user interacts with the main
  // content area. Same UX as the Insights page: the user can re-open the
  // nav, and the next click in the page will fold it away again so the
  // content has full width. Listener is attached to the content wrapper
  // so clicks on the nav (or fixed navbar) don't trigger the collapse.
  const contentRef = useRef(null);
  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    const collapse = () => {
      setStoredSidebarState(false);
      setSidebarState(false);
    };
    el.addEventListener("pointerdown", collapse, { capture: true });
    return () => el.removeEventListener("pointerdown", collapse, { capture: true });
  }, [setStoredSidebarState, setSidebarState]);

  const sidebarW = useBreakpointValue({
    base: "full",
    md: "14",
    lg: storedSidebarState ? "64" : "14",
  });

  const sidebarBorder = useBreakpointValue({
    base: "none",
    md: "thin",
  });

  const contentOpacity = useBreakpointValue({
    base: sidebarState ? 0 : 1,
    lg: 1,
  });

  const contentPointerEvents = useBreakpointValue({
    base: sidebarState ? "none" : "all",
    lg: "all",
  });

  const navbarBg = useColorModeValue("white", "gray.800");

  return (
    <>
      {navbar && (
        <Box
          position="fixed"
          top={0}
          insetInline={0}
          bg={navbarBg}
          zIndex={20}
          borderBottom="1px"
          borderColor="gray.300"
        >
          {navbar}
        </Box>
      )}
      <Flex id="layout" direction="column" blockSize="100vh" inlineSize="full" overflow="hidden">
        {/* Spacer for the fixed navbar */}
        {navbar && <Box flexShrink={0} h="71px" />}
        <Flex flexGrow={1} overflow="hidden" blockSize="full">
          {sidebar && (
            <Box
              borderInlineEndWidth={sidebarBorder}
              inlineSize={sidebarW}
              blockSize="full"
              transitionTimingFunction="ease"
              transitionDuration="200ms"
              bg="#1155a5"
            >
              {sidebar}
            </Box>
          )}
          <Box
            id="layoutContainer"
            ref={contentRef}
            flex={1}
            blockSize="full"
            overflowY="auto"
            overflowX="hidden"
            opacity={contentOpacity}
            pointerEvents={contentPointerEvents}
            transitionTimingFunction="ease"
            transitionDuration="200ms"
          >
            <Box flexGrow={1} zIndex={1} backgroundColor="layout_background">
              {children}
            </Box>
          </Box>
        </Flex>
      </Flex>
      <RightSidebarWidget />
    </>
  );
}

export default Layout;
